import React from 'react';
import PropTypes from 'prop-types';

import Modal from '../../../common/Modal/index';
import EditForm from './EditForm';

export default function Edit({
  closeModal, modalIsOpen, rowData, hasStrictPasswordRequirement, updatePath, updateTable, userIsSysadmin, flags
}) {
  return (
    <Modal
      closeModal={closeModal}
      headerText="Edit Student"
      isOpen={modalIsOpen}
    >
      <EditForm
        closeModal={closeModal}
        flags={flags}
        hasStrictPasswordRequirement={hasStrictPasswordRequirement}
        student={rowData}
        updatePath={updatePath}
        updateTable={updateTable}
        userIsSysadmin={userIsSysadmin}
      />
    </Modal>
  );
}

Edit.propTypes = {
  closeModal: PropTypes.func.isRequired,
  flags: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired
  })).isRequired,
  hasStrictPasswordRequirement: PropTypes.bool.isRequired,
  modalIsOpen: PropTypes.bool.isRequired,
  rowData: PropTypes.shape({
    first_name: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
    last_name: PropTypes.string.isRequired,
    uid: PropTypes.string,
    username: PropTypes.string.isRequired
  }).isRequired,
  updatePath: PropTypes.string.isRequired,
  updateTable: PropTypes.func.isRequired,
  userIsSysadmin: PropTypes.bool.isRequired
};
